import { useStaticQuery, graphql } from "gatsby"

export const useContenuLibre = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allNodeContenuLibre(sort: { fields: created, order: DESC }) {
          ...AllContenuLibre
        }
        allNodeTeleformulaires(sort: { fields: created, order: DESC }) {
          ...AllTeleform
        }
      }
    `
  )
  return data
}

export const queryContenuLibre = graphql`
  fragment AllContenuLibre on node__contenu_libreConnection {
    edges {
      node {
        created(formatString: "YYYY/MM/DD", locale: "en")
        body {
          processed
        }
        internal {
          type
        }
        title
        relationships {
          field_taxonomie_zone_libre {
            name
          }
        }
      }
    }
  }
`

export const queryTeleform = graphql`
  fragment AllTeleform on node__teleformulairesConnection {
    edges {
      node {
        title
        created(formatString: "YYYY/MM/DD", locale: "en")
        body {
          summary
          processed
        }
        path {
          alias
        }
        field_lien_demarches_simplifiees {
          title
          uri
        }
        internal {
          type
        }
        relationships {
          field_taxonomie_zone_libre {
            name
          }
          field_taxonomie_teleformulaire {
            name
            path {
              alias
            }
          }
        }
      }
    }
  }
`
